module.exports = __webpack_public_path__ + "media/images/welcome-bg-5ae453678ce0439cf7379f91c04af4af.jpg";